<template>
  <el-dialog
      v-model="modelShow"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      draggable
      title="公式指标设置"
      width="1200px"
  >
    <el-tabs tab-position="left" v-model="setType">
      <el-tab-pane label="基础运算" name="1">
        <div className="tabContainer">
          <div class="fieldTree" :class="{ bigScreen: isBigScreen }">
            <zk-tree
                title="选择字段"
                :data="computedData"
                :draggable="true"
                :allow-drag="isDragAble"
                :allow-drop="() => false"
                @node-drag-start="handleDragStart"
                @node-drag-end="handleDragEnd"
                nodeKey="code"
            ></zk-tree>
            <FormulaSet
                ref="formulaComponent"
                @saveCallBack="handleSave"
                :initData="initData"
                :variableList="computedData"
            ></FormulaSet>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="高级运算" name="2" :disabled="true"></el-tab-pane>
    </el-tabs>
    <template #footer>
      <el-button type="primary" @click="confirm">确认</el-button>
      <el-button @click="cancel">取消</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import {computed, nextTick, ref, watch} from 'vue';
import {ElMessage} from 'element-plus';
// import FormulaSet from '../valueFormat/formulaSet.vue'
import FormulaSet from '../valueFormat/formulaSetNew.vue';

const emits = defineEmits(['update:modelValue', 'confirm']);
const props = defineProps({
  modelValue: {
    type: Boolean
  },
  option: {},
  initData: {
    type: Array,
    default: () => []
  }
});
//  暂存data
const data = ref([
  {
    id: 1,
    type: 'metrics',
    label: '可选指标',
    children: []
  },
  {
    id: 2,
    type: 'pageParams',
    label: '页面参数',
    children: []
  }
]);

let getApp = inject('getApp', null);
let app = getApp ? getApp() : inject('app');
const modelShow = computed({
  get: () => {
    return props.modelValue;
  },
  set: val => {
    emits('update:modelValue', val);
  }
});

let computedData = computed(() => {
  return modelShow.value
      ? data.value.map(item => {
        let children = [];
        if (item.type === 'metrics') {
          const {assistMetrics = [], metrics = []} = props?.option;
          children = [...assistMetrics, ...metrics]?.filter(
              metric => metric.fieldType === 'Number'
          );
          children = children.map(item => {
            return {
              ...item,
              name: item.fieldName,
              label: item.name
            };
          });
        } else if (item.type === 'pageParams') {
          const {pageParams = []} = app;
          children = pageParams.filter(param => param.fieldType === 'number');
          children = children.map(item => {
            return {
              ...item,
              fieldType: 'pageParams',
              code: item.fieldKey,
              name: item.fieldName,
              label: item.fieldName
            };
          });
        }
        return {
          ...item,
          children
        };
      })
      : [];
});
let setType = ref('1');
const formulaComponent = ref(null); // 公式

onBeforeMount(() => {
  console.log('props>>>>>>>>>>>>>>', props.initData);
});

let isBigScreen = computed(() => {
  let editorType = inject('editorType');
  return editorType == 1 ? true : false;
});

async function confirm() {
  await formulaComponent.value.handleSave();
}

// 取消
function cancel() {
  emits('update:modelValue', false);
}

// 拖拽事件
const handleDragStart = (node, e) => {
  const data = {
    ...node.data,
    name: node.data.label
  };
  e.dataTransfer.setData('drag-info', JSON.stringify(data));
};

const handleDragEnd = (node, nodeE, p, e) => {
  e.dataTransfer.clearData(); //拖拽事件结束，清除消息
};
// 拖拽判断
const isDragAble = node => {
  if (node.level === 1) {
    return false;
  }
  return true;
};
// 保存
const handleSave = async calcRes => {
  if (!calcRes || !calcRes.formulaData.length) {
    ElMessage.warning('公式配置不能为空');
    return;
  }
  emits('confirm', calcRes);
  emits('update:modelValue', false);
};

defineExpose({});
</script>

<style lang="scss" scoped>
.tabContainer {
  display: flex;

  .ks-tree {
    background-color: transparent;
    color: #ffffff;
  }

  .fieldTree {
    display: contents;
  }

  :deep(.ks-tree-title) {
    h2 {
      color: #000000;
      font-size: 14px;
      font-weight: 900;
    }
  }

  .bigScreen :deep(.ks-tree-title) {
    h2 {
      color: #ffffff;
    }
  }

  :deep(.ks-tree-container) {
    background-color: transparent;
    color: #ffffff;
  }

  .bigScreen :deep(.zk-toottip > .text-box) {
    color: #ffffff;
  }

  :deep(.el-tree-node.is-current > .el-tree-node__content) {
    background-color: transparent;
  }

  :deep(.el-tree-node__content:hover) {
    background-color: transparent;
  }

  :deep(.el-tree-node:focus > .el-tree-node__content) {
    background-color: transparent;
  }

  :deep(.is-current > .el-tree-node__content:before) {
    display: none;
  }
}
</style>
